import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IPlatformUserOskVm } from '../platform-user-osk-vm.model';
import { IPlatformUserOskUm } from '../platform-user-osk-um.model';

@Injectable({ providedIn: 'root' })
export class PlatformUserOskService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/PlatformUserOsk`;
  }

  get(userGuid: string): Observable<IPlatformUserOskVm> {
    const headers = this.createHeaders();
    const params = new HttpParams().set('userGuid', userGuid);
    return this.http.get<IPlatformUserOskVm>(this.baseUrl, { headers, params });
  }

  put(platformUserOskUm: IPlatformUserOskUm): Observable<IPlatformUserOskVm> {
    const headers = this.createHeaders();
    return this.http.put<IPlatformUserOskVm>(this.baseUrl, platformUserOskUm, { headers });
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
